module.exports = __webpack_public_path__ + "media/images/app/homepage/hero_2-f495ba21594c2e6750ff7a19497110bc.webp";